// Preferences saved and restored from window.localStorage

import _ from 'lodash'
import Vue from 'vue'

const DEFAULT_PREFS = {
  desktop: {
    advancedSearch: false,
    showZoomButtons: true,
    tapToChangePages: false,
  },
  mobile: {
    advancedSearch: false,
    showZoomButtons: false,
    tapToChangePages: false,
  },
}

export default new Vue({
  data() {
    return {
      defaults: DEFAULT_PREFS.mobile,
      ...DEFAULT_PREFS.mobile,
    }
  },

  created() {
    this.load()
  },

  watch: {
    defaults: function () {
      this.load()
    },
  },

  methods: {
    load() {
      let stored
      try {
        stored = JSON.parse(window.localStorage.getItem('readerPrefs'))
      } catch (e) {
        console.error(e)
      }
      if (!stored) {
        stored = {}
      }
      if (this.watches) {
        for (const unwatch of this.watches) {
          unwatch()
        }
      }
      this.watches = _(this.defaults)
        .toPairs()
        .map(([k, dv]) => {
          const sv = stored[k]
          Vue.set(this, k, sv === undefined ? dv : sv)
          return this.$watch(k, () => {
            this.save()
          })
        })
        .value()
    },

    save() {
      const stored = _(this.defaults)
        .toPairs()
        .map(([k, dv]) => [k, this.$data[k], dv])
        .filter(([, sv, dv]) => sv !== undefined && sv !== dv)
        .fromPairs()
        .value()
      window.localStorage.setItem('readerPrefs', JSON.stringify(stored))
    },

    setDefaults(key) {
      this.defaults = DEFAULT_PREFS[key]
    },

    reset() {
      Object.assign(this, this.defaults)
    },
  },
})
